export const isExerciseAdministrationPath = (pathname: string): boolean =>
  /^\/(?:(?:nl|en)\/)?admin-exercise-library\/?$/i.test(pathname);
